<div class="ontario-row">
  <div class="ontario-column ontario-small-12">
    <h2 id="pageTitle">{{ 'bss.certi.title' | translate }}</h2>
    <hr>
    <p [innerHTML]="'bss.certi.validProvide' | translate"></p>
    <p [innerHTML]="'bss.certi.toImportCerti' | translate"></p>
    <p [innerHTML]="'bss.certi.step1' | translate"></p>
    <p><img src='assets/icons/certificate/step1a.gif' title="{{ 'bss.certi.step1' | translate }}" role='img' /></p>
    <p [innerHTML]="'bss.certi.step1Or' | translate"></p>
    <p><img src='assets/icons/certificate/step1b.gif' title="{{ 'bss.certi.step1Or' | translate }}" role='img' width="600" height="300"/></p>
    <p [innerHTML]="'bss.certi.step2' | translate"></p>
    <p><img src='assets/icons/certificate/step2.gif' title="{{ 'bss.certi.step2' | translate }}" role='img' /></p>
    <p [innerHTML]="'bss.certi.step3' | translate"></p>
    <p><img src='assets/icons/certificate/step3a.gif' title="{{ 'bss.certi.step3' | translate }}" role='img' width="600" height="200"/></p>
    <p [innerHTML]="'bss.certi.step3And' | translate"></p>
    <p><img src='assets/icons/certificate/step3b.gif' title="{{ 'bss.certi.step3And' | translate }}" role='img' width="600" height="200"/></p>
    <p [innerHTML]="'bss.certi.step4' | translate"></p>
    <p><img src='assets/icons/certificate/step4n.gif' title="{{ 'bss.certi.step4' | translate }}" role='img' width="600" height="200"/></p>
    <p [innerHTML]="'bss.certi.thisAdds' | translate"></p>
    <p [innerHTML]="'bss.certi.step5' | translate"></p>
  </div>
</div>